<template>
<svg viewBox="0 0 49 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-storage-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40.093 31.11a2.37 2.37 0 012.37 2.371v5.926a2.37 2.37 0 01-2.37 2.37H9.537a2.37 2.37 0 01-2.37-2.37v-5.926a2.37 2.37 0 012.37-2.37h30.556zM37.248 34.5h-2.607a.474.474 0 00-.45.324l-.024.15v3.068c0 .21.136.387.324.45l.15.024h2.607c.21 0 .387-.136.45-.325l.024-.15v-3.067a.474.474 0 00-.474-.474zm2.845-16.425a2.37 2.37 0 012.37 2.37v5.926a2.37 2.37 0 01-2.37 2.37H9.537a2.37 2.37 0 01-2.37-2.37v-5.926a2.37 2.37 0 012.37-2.37h30.556zm-2.845 3.388h-2.607a.474.474 0 00-.45.324l-.024.15v3.068c0 .209.136.387.324.45l.15.024h2.607c.21 0 .387-.136.45-.325l.024-.15v-3.067a.474.474 0 00-.474-.474zm2.845-16.425a2.37 2.37 0 012.37 2.37v5.926a2.37 2.37 0 01-2.37 2.37H9.537a2.37 2.37 0 01-2.37-2.37V7.407a2.37 2.37 0 012.37-2.37h30.556zm-2.845 3.388h-2.607a.474.474 0 00-.45.324l-.024.15v3.068c0 .209.136.387.324.45l.15.024h2.607c.21 0 .387-.136.45-.325l.024-.15V8.9a.474.474 0 00-.474-.474z"/></svg>
</template>
<script>

export default {
  name: 'IconStorageFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
